<template>
  <div>
    <div class="container-fluid white-bg no-shadow">
      <div class="container align-middle">
        <div class="row">
          <div class="col-12">
            <div class="land-t-delimeter" style="margin-bottom: 60px;"></div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <p>Все родители знают, как увлечены гаджетами современные подростки! Многие из них уделяют компьютеру и планшету больше времени, чем подготовке к занятиям в школе. Но цифровым технологиям можно найти достойное применение: чтобы ваш ребёнок успешно подготовился ЕГЭ по английскому языку, запишите его на курсы образовательной платформы HomeTeacher &nbsp;от международного языкового центра Полиглотики.</p>

            <h2 class="greenh2">Что нужно знать о платформе HomeТeacher</h2>

            <p>HomeTeacher &mdash; это платформа, на которой представлены онлайн-уроки английского языка для детей 12-17 лет. При создании видеокурсов используются те же принципы и методики, что и при проведении очных занятий с группами, разумеется, с поправкой на форму обучения.</p>

            <p>Занятия на платформе помогут подросткам:</p>

            <ul>
              <li><span>расширить словарный запас и улучшить произношение.</span></li>
              <li><span>повторить школьную программу и восполнить пробелы в знаниях.</span></li>
              <li><span>приобрести навыки аудирования, то есть научиться понимать английскую речь и правильно отвечать на вопросы.</span></li>
            </ul>

            <p>Опыт показывает, что дистанционное обучение английскому языку для детей 12-17 лет по уровню эффективности практически не уступает офлайн-занятиям в классе. Хороший результат достигается благодаря применению специально созданных методических пособий, а также разработке языковых курсов с учётом новейших открытий в области нейрофизиологии и нейропедагогики.</p>

            <h2 class="greenh2">Преимущества занятий на платформе</h2>
            <ol>
              <li><span>Качественное преподавание. Эффективное обучение английскому языку старших школьников невозможно без сугубо профессионального подхода. Поэтому в создании видеоуроков на платформе HomeTeacher принимают участие исключительно опытные преподаватели, в том числе носители языка, а также методисты и дизайнеры. Усилиями команды &laquo;Полиглотиков&raquo; разработано более 70 учебных программ для детей разных возрастов.</span></li>

              <li><span>Разумные цены. Онлайн-курсы английского языка для школьников значительно дешевле занятий с репетитором: стоимость одного урока начинается от 90 рублей, а месячный курс можно приобрести по цене от 990 р. Мы позаботились о том, чтобы дистанционное обучение было доступно всем желающим: вам не понадобится дорогостоящая техника, ведь для просмотра видео достаточно обычного телефона или планшета.</span></li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
name: "Lang1Age4"
}
</script>

<style scoped>
.no-shadow p,li{color: #000; font-size: 18px;}
.no-shadow ul li{margin-bottom: 20px; padding-left: 10px;}
.no-shadow ul {list-style-image: url(~@/assets/hometeacher/images/redok.png);}
.no-shadow{margin-bottom: 70px;}
.no-shadow li{font-family: "Manrope Bold"; color:#5ab947;}
.no-shadow li span {font-family: "Manrope Light"; color: #000;}
.no-shadow ol li{margin-bottom: 20px; padding-left: 5px;}
</style>
